export default {
  create_title: 'Uusi Partner API -tili',
  edit_title: 'Muokkaa tiliä',
  form: {
    name: 'Tilin nimi',
    name_placeholder: 'esim. Acme POS-integraatio',
    contact_email: 'Yhteyshenkilön sähköposti',
    scope: 'Ravintolakäyttöoikeus',
    companies: 'Ravintolat',
    scope_selected: 'Valitut ravintolat',
    scope_all: 'Kaikki ravintolat',
    scope_all_help:
      'Tämän tilin avaimet ulottuvat jokaiseen organisaatiosi ravintolaan, myös myöhemmin rekisteröityihin.',
    companies_placeholder: 'Valitse ravintolat',
    companies_help: 'Tälle tilille luodut avaimet voivat lukea ja kirjoittaa vain näitä ravintoloita.',
    is_active: 'Aktiivinen',
    is_active_help: 'Ei-aktiiviset tilit hylätään todennuksessa.',
  },
  buttons: {
    cancel: 'Peruuta',
    save: 'Tallenna',
    create: 'Luo',
  },
  toasts: {
    created: 'Partner API -tili luotu.',
    updated: 'Tili päivitetty.',
    error: 'Tiliä ei voitu tallentaa.',
  },
};
